// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__ArCl3","content":"layout_content__4pby2"};